import { DocFlowSendingContext } from '../DocFlowSending'

function DocFlowSendingProvider({ children, ...restProps }) {
  return (
    <DocFlowSendingContext value={restProps}>{children}</DocFlowSendingContext>
  )
}

export default DocFlowSendingProvider
